import React, { PureComponent } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import { SignUp, finishReg, Processing } from 'cloak-file-sdk-web';
import { modalStyles } from '../styles/styles'
import { createGuestRegUsage } from '../reducers/newLandingReducer'
import * as cloakAnalytics from '../services/cloakAnalytics';

var modalStyle = modalStyles.doubleLineModal


class SignUpPage extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            redirectToLogin: false
        }
    }

    componentDidMount() {
        // Cloak Files signup funnel: signal intent + plan as soon as the user
        // arrives on /cloak/signup. The ?plan= query is set by the marketing
        // site CTAs (encrypt-solo / -team / -business).
        try {
            const params = new URLSearchParams(window.location.search);
            const plan = params.get('plan');
            cloakAnalytics.trackSignupStarted('cloak_signup', plan);
            if (plan) {
                const priceUsd = cloakAnalytics.priceForCloakFilesPlan(plan);
                cloakAnalytics.trackPlanSelected(plan, priceUsd);
            }
        } catch (e) { /* analytics never blocks signup */ }
    }

    onClick() {
        this.props.dispatch(finishReg(true))
        this.setState({ redirectToLogin: true });
    }

    render() {
        const { intl } = this.props
        const { status, reg_error, regInProcess } = this.props;

        if (this.state.redirectToLogin) {
            return (
                <Navigate to="/cloak/login" />
            )
        }

        var url = new URL(window.location.href)
        console.log("url " + url)
        var email = url.searchParams.get("email")
        console.log("email " + email)
        // code is for guest recipients signup
        var code = url.searchParams.get("code")
        console.log("code " + code)
        var campaignId = url.searchParams.get("campaign_id")
        console.log("campaignId " + campaignId)
        this.props.dispatch(createGuestRegUsage(email, campaignId))

        if (regInProcess && status === null && !reg_error) {
            modalStyle = modalStyles.singleLineModal
        } else {
            modalStyle = modalStyles.doubleLineModal
        }
        const message = (
            <div>
                {(regInProcess && status === 200 && code) && <FormattedMessage id="signUp.guestSuccessMessage" />}
                {(regInProcess && status === null && !reg_error) && <FormattedMessage id="signUp.registering" />}
                {(regInProcess && status === 200 && !code) && <FormattedMessage id="signUp.verifyMessage" />}
            </div>
        )

        const children = (
            <div>
                {
                    (regInProcess && status === 200) &&
                    <div className="clk-modal-button-div">
                        <br />
                        <button className="clk-modal-button" onClick={() => this.onClick()}>
                            <FormattedMessage id="signUp.ok" />
                        </button>
                    </div>
                }
            </div>
        )

        console.log("regInProcess: " + regInProcess)
        console.log("status: " + status)
        console.log("message: %o", message)
        return (
            <div className="clk-primary-console-div">
                <div className="clk-primary-console clk-box-shadow ">
                    <div className="clk-signup-div">
                        <Processing show={regInProcess}
                            processing={regInProcess && status === null && !reg_error}
                            style={modalStyle}
                            message={message}
                            messageStyle={{ marginTop: 10, color: '#a6a6a6' }}
                            children={children} />

                        <div className="clk-main-title-div">
                            <div className="clk-main-title-text">
                                <FormattedMessage id="signUp.title" />
                            </div>
                        </div>

                        <SignUp emailLabel={intl.formatMessage({ id: 'signUp.email' })}
                            pwdLabel={intl.formatMessage({ id: 'signUp.password' })}
                            cnfrmPwdLabel={intl.formatMessage({ id: 'signUp.confirmPwd' })}
                            actionTitle={intl.formatMessage({ id: 'signUp.title' })}
                            email={email}
                            code={code}
                            campaignId={campaignId} />
                    </div>
                </div>
            </div>
        );
    }
}

SignUpPage.propTypes = {
    error: PropTypes.string,
    showError: PropTypes.bool,
    onSuccess: PropTypes.func
}

SignUpPage.defaultProps = {
    error: '',
    showError: true
}

const mapStateToProps = state => {
    return {
        status: state.reg.reg_status,
        reg_error: state.reg.reg_error,
        regInProcess: state.reg.regInProcess
    }
};


export default connect(mapStateToProps)(injectIntl(SignUpPage));
